<template>
  <div class="goods-box my-form">
    <h2>完善资料解锁更多权限</h2>

    <div class="registered">
        <van-form @submit="onSubmit" show-error :show-error-message="false">
            <van-field
                v-model="form.Username"
                name="姓名"
                label="姓名"
                placeholder="请输入姓名"
                required
                :rules="[{ required: true, message: '请填写用户名' }]"
            />
            <van-field
                v-model="form.Phone"
                type="number"
                name="pattern"
                label="手机"
                maxlength="11"
                placeholder="请输入手机"
                required
                :rules="[{ pattern, message: '请填写手机' }]"
            />
            <van-field
                v-model="code"
                center
                clearable
                label="验证码"
                maxlength="6"
                placeholder="请输入验证码"
                required
                :rules="[{ required: true, message: '请输入验证码' }]"
                >
                <template #button>
                    <span class="code" v-if="newTimer">{{ newCount || 0}}s重新发送</span>
                    <span class="sendcode code" v-else @click="getCode">发送验证码</span>
                </template>
            </van-field>
             <van-field
                v-model="form.CompName"
                type="text"
                name="公司"
                label="公司"
                placeholder="请输入公司"
                required
                :rules="[{ required: true, message: '请填写公司' }]"
            />
             <van-field
                v-model="form.JobTitle"
                type="text"
                name="职务"
                label="职务"
                placeholder="请输入职务"
                required
                :rules="[{ required: true, message: '请填写职务' }]"
            />

            <div class="vant-btn">
                <van-button round block type="info"  native-type="submit">
                   保存
                </van-button>
            </div>
        </van-form>
    </div>
     

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {
        Username: "", // 姓名
        Phone: "", // 手机号
        CompName: "", // 公司名
        JobTitle: "", // 职务
      },
      code:'',
      count: 0,
      newCount: 0,
      timer: null,
      newTimer: null,
      pattern: /^1[3456789]\d{9}$/, // 校验手机号
      codeKey:'',
    };
  },
  computed: {
    ...mapGetters({
      user: "getUserInfo",
      categoryList:'getCategory',
      userId:"getUserId",
      hostInfo:"getHostInfo",
    }),
  },
  created() { 
      this.init();
  },
  methods: {
    ...mapActions({
      patchUser:'my/patchUser',
      sendCode:'my/sendCode',
      validateCode:'my/validateCode',
      putPhone:'my/putPhone',
    }),
    async init(){
      await this.$Myapollo.getUserInfo(this);
      this.form.Username = this.user.nickName;
      this.form.Phone = this.user.phone;
      this.form.CompName = this.user.company;
      this.form.JobTitle = this.user.jobTitle;
    },
    async onSubmit(){
      let checkRes =  await this.Checkphone();
      if(checkRes) {
        let opt = {
          id:this.user.id,
          body:{
            name:this.form.Username,
            company:this.form.CompName,
            jobTitle:this.form.JobTitle,
          }
        }
        let MobBody = {
          memberId:this.user.id,
          phonenNumber:this.form.Phone,
        }
        this.putPhone(MobBody);
        let data = await this.patchUser(opt);
        if(data.result){
          this.$toast.success('保存成功');
          // this.$Myapollo.getUserInfo(this);
          setTimeout(()=>{
            this.$router.go(-1);
          },1000)
        }
      }
    },
    //手机号校验
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    // 获取手机号验证码
    async getCode(){
      console.log(this.form.Phone,'123213')
      if (!this.validatorPhone(this.form.Phone)) {
        this.$toast.fail('请输入正确的手机号')
        return;
      } else {
        this.newDownTime();
        let res = await this.sendCode({
          PhoneNumber: this.form.Phone
        });
        if (res.result) {
          this.codeKey = res.data.key;
        } else {
          this.$toast.fail('发送失败')
        }
      }
    },
    //验证手机号
    async Checkphone() {
      let res = await this.validateCode({
        key: this.codeKey,
        code: this.code
      });
      return new Promise((resolve, reject) => {
        if (res == true) {
          this.resetDown();
          resolve(true);
        } else {
          this.$toast.fail('手机号验证失败')
          this.resetDown();
          resolve(false);
        }
      })
    },


    resetDown(){ // 重置验证码
      clearInterval(this.newTimer);
      this.newCount = 0;
      this.newTimer = null;
      this.code = "";
    },

    //新手机号倒计时
    newDownTime() {
      const newTIME_COUNT = 60;
      if (!this.newTimer) {
        this.newCount = newTIME_COUNT;
        const newTimer = setInterval(() => {
          let count = this.newCount;
          if (count > 0 && count <= newTIME_COUNT) {
            count--;
            this.newCount = count;
          } else {
            clearInterval(this.newTimer);
            this.newTimer = null;
          }
        }, 1000);
        this.newTimer = newTimer;
      }
    },
    
  },

};
</script>

<style lang="scss" scoped>
h2{
    font-size: .26rem;
	font-weight: normal;
	font-stretch: normal;
	color: #666;
    padding: .23rem 0 .26rem 16px;
    text-align: left;
    width: 100%;
}
.goods-box {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    margin:.45rem 0;
  }
  .registered {
    width: 100%;
    padding-bottom: .9rem;
    .code{
        font-size: .3rem;
    }
    .sendcode{
        color: #0190fe;
    }
    .single-checkbox{
        margin:.6rem 0 .8rem .3rem;
        display: flex;
        p{
           font-size: .3rem; 
           margin-left: 5px;
           color: #666;
        }
        span{
            font-size: .3rem;
            color: #1890ff
        }
    }
    .vant-btn{
        position: fixed;
        left:0;
        bottom: 0;
        z-index: 100;
        width: 100%;
        background: #fff;
        height: .94rem;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 0px 3px 0px 
        rgba(0, 0, 0, 0.2);
        .van-button--block{
            width: 6.5rem;
            height: .74rem;
            line-height: .74rem;
        }
        span{
            font-size: .3rem;
        }
    }
    

    }
}
</style>